<template>
  <div class="public-img-com">
    <div class="left">
      <uploadBase
        ref="uploadRef"
        :btnName="'上传新图片'"
        :uploadMethod="'uploadAttach'"
        :acceptList="'image/png, image/jpeg, image/jpg'"
        :extaParam="{
          isPicture: 1
        }"
        :fileSize="10"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload"></uploadBase>
    </div>
    <div v-if="attcahList.length" class="middle">或者选择<br>已有素材</div>
    <div v-if="attcahList.length" class="right" v-loading='listLoading'>
      <div class="img-wrap" v-for="(item, index) in attcahList" :key="item.id" @click="selectAttach(item)">
        <img :src="item.upload" alt="">
        <i class="el-icon-close" @click.stop="deleteAttach(item.id, index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index.js'
import uploadBase from '@/components/uploadBase'
export default {
  data () {
    return {
      listLoading: false,
      attcahList: []
    }
  },
  mounted () {
    this.getList()
  },
  activated () {
    this.getList()
  },
  methods: {
    handleSuccess (url) {
      this.$emit('dispachUrl', url)
      this.getList()
    },
    getList () {
      api.getAttachList({
        isPicture: 1,
        pages: 50,
        pageNo: 1
      }).then(res => {
        if (res.code === 200) {
          this.attcahList = res.data.list
        }
      })
    },
    selectAttach (item) {
      this.$emit('dispachUrl', item)
    },
    deleteAttach (id, index) {
      this.listLoading = true
      api.deleteAttach({
        id: id
      }).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.attcahList.splice(index, 1)
        }
      })
    },
    checkUpload () {
      if (this.attcahList.length >= 50) {
        this.$message({
          message: '每个用户最多拥有50张照片，请删除一条后再试',
          type: 'warning'
        })
        return
      }
      this.$refs.uploadRef.doUpload()
    }
  },
  components: {
    uploadBase
  }
}
</script>

<style lang="scss">
  .public-img-com {
    display: flex;
    justify-content: center;
    align-items: center;
    .upload-main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .el-upload-right {
        flex: 0;
        .el-form-item {
          margin-bottom: 0;
        }
        .el-cascader {
          margin-bottom: 0!important;
        }
        .el-form-item__error {
          padding-top: 0;
          top: 40px;
        }
        .el-date-editor.el-input {
          width: 172px;
          margin-bottom: 12px;
        }
        .el-select, .el-cascader {
          margin-bottom: 12px;
        }
      }
      .el-upload-dragger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 140px;
      }
      .el-upload-dragger {
        height: 140px;
      }
      .el-icon-upload {
        margin: 0;
      }
      label {
        display: block;
      }
    }
    .left {
      .upload-action {
        margin-top: 20px;
        text-align: center;
      }
    }
    .middle {
      flex: 0 0 auto;
      margin: 0 12px;
    }
    .right {
      flex: 1 1 140px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      height: 188px;
      overflow: auto;
      display: flex;
      flex-wrap: wrap;
      padding: 12px;
      align-items: flex-start;
      .img-wrap {
        position: relative;
        i {
          position: absolute;
          background: #fff;
          border: 1px solid #F56C6C;
          right: 0;
          top: -8px;
          border-radius: 50%;
          color: #F56C6C;
          cursor: pointer;
        }
        img {
          width: 52px;
          margin: 0 6px 6px 0;
          cursor: pointer;
          border: 1px dashed transparent;
          border-radius: 4px;
          display: block;
          &:hover {
            border-color: #409eff;
          }
        }
      }
    }
  }
</style>
